import { normalizePositionString } from './normalize'
import type { PositionDef, PositionResolver } from './types'

export function createPositionResolver<T extends string>(
  positions: ReadonlyArray<PositionDef<T>>
): PositionResolver<T> {
  const aliasMap = new Map<string, T>()
  const canonicalMap = new Map<T, PositionDef<T>>()

  for (const def of positions) {
    canonicalMap.set(def.canonical, def)
    const candidates = [
      def.canonical,
      def.abbreviation,
      def.label,
      ...def.aliases
    ]
    for (const candidate of candidates) {
      if (!candidate) continue
      aliasMap.set(normalizePositionString(candidate), def.canonical)
    }
  }

  return {
    positions,
    byCanonical: (canonical) => canonicalMap.get(canonical),
    resolve: (input) => {
      if (input == null) return null
      const key = normalizePositionString(input)
      if (!key) return null
      return aliasMap.get(key) ?? null
    }
  }
}
